export const slideScripts = {
  introduction: {
    title: 'Introduction Script',
    keyPoints: [
      'Welcome client by name',
      'Build rapport with small talk',
      'Set expectations for the session'
    ],
    script: `
      "Thank you for taking the time to speak with me today. During our conversation, I'll be walking you through a detailed analysis of your current financial situation and showing you how our program can help you achieve your financial goals.

      We'll look at your current credit utilization, calculate how much interest you're paying, and explore options that could significantly reduce your monthly payments while helping you become debt-free sooner.

      Do you have any questions before we begin?"
    `
  },
  creditAnalysis: {
    title: 'Credit Analysis Script',
    keyPoints: [
      'Highlight high utilization',
      'Emphasize impact on credit score',
      'Show total monthly burden'
    ],
    script: `
      "Let's look at your current credit situation. As you can see, your overall credit utilization is [percentage]%, which is significantly higher than the recommended 30%.

      Notice how much you're paying each month just to maintain minimum payments. That's [total monthly payment] going out every month, and unfortunately, most of it is just covering interest rather than reducing your balances.

      What concerns you most about your current credit card situation?"
    `
  },
  interestCalculator: {
    title: 'Interest Analysis Script',
    keyPoints: [
      'Show monthly interest burden',
      'Calculate annual interest waste',
      'Demonstrate the debt trap'
    ],
    script: `
      "This is perhaps the most important slide because it shows exactly how the credit card companies are profiting from your situation.

      You're currently paying [monthly interest] every month just in interest. That adds up to [annual interest] per year - money that's not reducing your balance at all.

      How do you feel about paying this much in interest each year?"
    `
  },
  termOptions: {
    title: 'Program Terms Script',
    keyPoints: [
      'Present monthly savings',
      'Highlight total savings',
      'Emphasize fixed term'
    ],
    script: `
      "Now let's look at how we can help. Instead of paying [current payment] each month, our program could reduce your payment to [proposed payment].

      This program would run for [term] months, and by the end, you could save approximately [total savings].

      The best part is that this is a fixed term - you'll know exactly when you'll be debt-free."
    `
  },
  logistics: {
    title: 'Program Process Script',
    keyPoints: [
      'Explain each step clearly',
      'Address common concerns',
      'Build confidence in process'
    ],
    script: `
      "Let me walk you through exactly how our program works. We've broken it down into simple steps to make it as easy as possible for you.

      The key is that we'll be negotiating with your creditors on your behalf while you make one manageable monthly deposit into your dedicated account.

      Which step would you like me to explain in more detail?"
    `
  },
  summary: {
    title: 'Summary Script',
    keyPoints: [
      'Recap key benefits',
      'Compare current vs proposed',
      'Handle objections'
    ],
    script: `
      "Let's review the key benefits of the program:
      - Your monthly payment would drop from [current] to [proposed]
      - You could save [total savings] over the course of the program
      - You'll be debt-free in [term] months
      - You'll have just one monthly program payment to manage

      What questions do you have about these benefits?"
    `
  },
  additionalInfo: {
    title: 'Closing Script',
    keyPoints: [
      'Address remaining concerns',
      'Review next steps',
      'Close confidently'
    ],
    script: `
      "We've covered a lot of information today. The key takeaway is that we have a clear path to help you become debt-free.

      The next step is to complete some simple paperwork and set up your dedicated account. This whole process takes about 20-30 minutes.

      Would you like to get started now?"
    `
  }
};
